export default __webpack_public_path__ + "static/media/preview-2.c95a0cf2.jpg";